import type { PortableTextReactComponents } from "@portabletext/react";
import { convertYoutubeUrl } from "./utils";
import { sanitizeImageUrl } from "../../utils/sanity.utils";
import { InternalLink } from "./internal-link";
import { ArrowIcon } from "./assets/arrow.icon";
import { createMarkup } from "./utils";
import { ArrowIconMobile } from "./assets/arrow-mobile.icon";

export const blogComponents: Partial<PortableTextReactComponents> = {
  marks: {
    link: ({ value, children }) => {
      const { href } = value;
      return (
        <span className="inline-block border-b border-solid border-[#4132EB] leading-[0.8]">
          <a
            className="text-[#4132EB] font-spectral flex"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
            <span className="inline-block">
              <ArrowIcon className="hidden lg:block relative top-[-1px]" />
              <ArrowIconMobile className="lg:hidden" />
            </span>
          </a>
        </span>
      );
    },
  },
  types: {
    image: (props) => {
      return (
        <div className="lg:grid grid-cols-3">
          <img
            src={sanitizeImageUrl(props.value.asset._ref)}
            alt="Article image"
            loading="lazy"
            className="col-span-2 rounded-[20px] pt-9 pb-17 lg:pt-20 lg:pb-35"
          />
          <div className="col-span-1"></div>
        </div>
      );
    },
    bigImage: (props) => {
      return (
        <div className="lg:grid grid-cols-3">
          <img
            src={sanitizeImageUrl(props.value.asset._ref)}
            alt="Article image"
            loading="lazy"
            className="col-span-2 rounded-[20px] pt-9 pb-17 lg:pt-20 lg:pb-35"
          />
          <div className="col-span-1"></div>
        </div>
      );
    },
    youtubeLink: (props) => {
      return (
        <div className="lg:grid grid-cols-3 pb-15 lg:pb-30">
          <div className="col-span-2 relative pt-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-[20px]"
              src={convertYoutubeUrl(props.value.link)}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="col-span-1"></div>
        </div>
      );
    },
    internalLink: InternalLink,
    quote: (props) => {
      return (
        <div className="flex flex-col-reverse max-w-[1440px] m-auto lg:grid grid-cols-3 font-spectral">
          <p
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: props.value.text,
            }}
            className="col-span-2 max-w-[906px] col-span-2 text-day-base-base-900 pb-8 lg:pb-15 text-[17px] leading-[130%] lg:text-[24px] lg:leading-[130%]"
          ></p>
          <div className="col-span-1"></div>
        </div>
      );
    },
  },
  block: {
    h2: ({ children }) => {
      return (
        <div className="lg:grid grid-cols-3 font-suisse">
          <h2
            // eslint-disable-next-line
            dangerouslySetInnerHTML={createMarkup(children)}
            className="col-span-2 text-[28px] pt-10 pb-7 lg:pb-20 lg:pt-20 lg:text-[38px] leading-[110%]"
          ></h2>
          <div className="col-span-1"></div>
        </div>
      );
    },
    normal: ({ children }) => {
      return (
        <div className="lg:grid grid-cols-3 font-spectral">
          <div className="col-span-2 text-day-base-base-900 pb-8 lg:pb-15 text-[17px] leading-[130%] lg:text-[24px] lg:leading-[130%]">
            {children}
          </div>
          <div className="col-span-1"></div>
        </div>
      );
    },
  },
};
